import { render, staticRenderFns } from "./LocationDisplay.vue?vue&type=template&id=2f24d671&"
import script from "./LocationDisplay.vue?vue&type=script&lang=js&"
export * from "./LocationDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports